import { Button } from "semantic-ui-react";
import { ImageZoom } from "../NUI/ImageZoom";
import SIcon from "../NUI/StreamlineIcons/SIcon";
import { CTA_ON_CLICK_FUNCTION_IDS } from "../../contentful/components/CTA";

export const medCertModals = {
    [CTA_ON_CLICK_FUNCTION_IDS.OPEN_MEDCERT_PREV]: () => app.trigger(app.events.SHOW_POPUP, {pt:"cx_txt", pn:'med-cert-preview', size:"fullscreen", noCloseBtn:true, noHeader:true}),
    [CTA_ON_CLICK_FUNCTION_IDS.OPEN_MEDCERT_EMP]: () => app.trigger(app.events.SHOW_POPUP, {pt:"cx_txt", txt:'Can employers question a medical certificate?', pn:'med-cert-employers', noCloseBtn:true})
}

export const MedCertModal = (props) => {

    return (
        props?.pn === "med-cert-preview"
        ?   <div>
                <div className="bg-is2-blue px-4 py-2 text-white h-fit relative">
                    <div className="h-6 absolute left-4" onClick={props?.onClose}><SIcon name="chevron" size="xs" bold cls="rotate-90 cursor-pointer"/></div>
                    <h5 className="text-white !font-normal !text-base !mt-0 text-center">Example medical certificate</h5>
                </div>
                <div className="py-9 mx-auto">
                    <ImageZoom
                        src="https://storage.googleapis.com/instant-med-public/v2/med-cert-2.webp"
                        className="w-full mt-9 md:!w-1/2 md:mx-auto"
                        alt="med cert example"
                        />
                </div>
            </div>
        : 
        <div className="relative pb-[90px]">
            <p>The short answer is no. According to The Fair Work Act 2009 employers must accept a genuine certificate at face value.</p>
            <p>Employers also have no right under the Act to ask the medical practitioner for specific information regarding the employee’s illness or injury.</p>
            <p>Here is a quick summary of the rights and responsibilities of employers under the Act:</p>
            
            <ul className="list-disc list-inside !mb-4">
                <li>You have a legal right to ask an employee for evidence supporting their absence.</li>
                <li>You can ask employees for evidence after each and every absence.</li>
                <li>If the employee refuses your request, you do not need to pay them for the absence.</li>
                <li>You can’t demand a detailed diagnosis, but they can (and should) ask for confirmation that the employee is fit to do their job.</li>
                <li>You must accept a genuine medical certificate as conclusive proof of the employee’s illness.</li>
                <li>You should introduce a comprehensive workplace policy dealing with absences and evidence requirements.</li>
            </ul>

            <p>For more information visit our <a href="/faq" target="_blank" className="cursor-pointer">FAQS</a></p>

            <div className="fixed bottom-0 p-6 bg-white w-full right-0 left-0 rounded-b-[23px] border-t ">
                <Button primary fluid onClick={props?.onClose}>Close</Button>
            </div>
        </div>
    )
};
